import { Injectable } from '@angular/core';

@Injectable()
export class PageIdentifierService {
  private html: HTMLElement;
  private body: HTMLElement;

  constructor() {
    this.html = document.getElementsByTagName('html')[0];
    this.body = document.getElementsByTagName('body')[0];
  }


  setup(key: string): void {
    if (!this.html.classList.contains(key)) {
      this.html.classList.add(key);
    }

    if (!this.body.classList.contains(key)) {
      this.body.classList.add(key);
    }
  }

  remove(key: string): void {
    this.html.classList.remove(key);
    this.body.classList.remove(key);
  }
}
